module.exports = {
    every: (requirements = [], conditions) => requirements.every((requirementFn) => !!requirementFn(conditions))
};
